/**
 * @param {{feedbackText: string}} props 
 */
export default function FeedbackContainer(props) {
    return (
        <div class="panel panel-default">
            <div class="panel-heading">Feedback</div>
            <div class="panel-body">
                {props.feedbackText}
            </div>
        </div>
    );
}